﻿/*! @preserve start */
/* ---------------------------------------------
   LOGO STRIP — FULL WORKING VERSION
   --------------------------------------------- */

; (() => {
    "use strict";

    function init(strip) {
        const rail = strip.querySelector(".logo-strip__rail");
        const arrowsTop = strip.querySelector(".arrow-border--top .arrow-border__track");
        const arrowsBottom = strip.querySelector(".arrow-border--bottom .arrow-border__track");

        if (!rail || !arrowsTop || !arrowsBottom) return;
        if (rail.__ls_init) return;
        rail.__ls_init = true;

        const originalHTML = rail.innerHTML;
        if (!rail.__ls_dup) {
            let tries = 0;
            while (rail.scrollWidth <= rail.clientWidth && tries < 12) {
                rail.innerHTML += originalHTML;
                tries++;
            }
            rail.innerHTML += originalHTML;
            rail.__ls_dup = true;
        }

        const originalCount = rail.children.length / 2;
        let loopWidth = 0;
        let swCache = 0;

        function measureLoopWidth() {
            const items = rail.children;
            if (items.length >= originalCount + 1) {
                return items[originalCount].offsetLeft - items[0].offsetLeft;
            }
            return rail.scrollWidth / 2;
        }

        function getLoopWidth() {
            const sw = rail.scrollWidth;
            if (!loopWidth || sw !== swCache) {
                swCache = sw;
                loopWidth = measureLoopWidth();
            }
            return loopWidth;
        }

        function wrap() {
            const lw = getLoopWidth();
            if (!lw) return;
            while (rail.scrollLeft >= lw) rail.scrollLeft -= lw;
            while (rail.scrollLeft < 0) rail.scrollLeft += lw;
        }

        let down = false;
        let hover = false;
        let auto = true;
        let inertia = false;
        let dragged = false;

        let sx = 0;
        let ss = 0;

        const samples = [];
        const SAMPLE_WINDOW = 120;
        const AUTO_SPEED = 100;
        const FRICTION = 0.92;
        const MIN_VEL = 5;

        let last = 0;

        function finePointer() {
            return (
                window.matchMedia &&
                window.matchMedia("(hover:hover) and (pointer:fine)").matches
            );
        }

        function stopAuto() {
            auto = false;
        }
        function startAuto() {
            if (hover && finePointer()) return;
            auto = true;
            rail.classList.remove("snap");
        }

        function stopInertia() {
            inertia = false;
        }

        rail.addEventListener("pointerdown", function (e) {
            if (e.pointerType === "mouse" && e.button !== 0) return;
            stopInertia();
            down = true;
            dragged = false;
            stopAuto();

            rail.classList.add("dragging", "snap");
            sx = e.clientX;
            ss = rail.scrollLeft;

            samples.length = 0;
            samples.push({ t: performance.now(), x: rail.scrollLeft });

            rail.setPointerCapture(e.pointerId);
        });

        rail.addEventListener("pointermove", function (e) {
            if (!down) return;

            e.preventDefault();
            const dx = e.clientX - sx;
            if (Math.abs(dx) > 3) dragged = true;

            rail.scrollLeft = ss - dx;
            wrap();

            const now = performance.now();
            samples.push({ t: now, x: rail.scrollLeft });
            while (samples.length && now - samples[0].t > SAMPLE_WINDOW) {
                samples.shift();
            }
        });

        rail.addEventListener("pointerup", function () {
            if (!down) return;
            down = false;
            rail.classList.remove("dragging");

            let v = 0;
            if (samples.length >= 2) {
                const a = samples[0];
                const b = samples[samples.length - 1];
                const dt = (b.t - a.t) / 1000;
                if (dt > 0) v = (b.x - a.x) / dt;
            }

            if (Math.abs(v) > MIN_VEL) {
                inertia = true;
                rail.classList.remove("snap");
                step.vel = v;
            } else {
                startAuto();
            }
        });

        rail.addEventListener("lostpointercapture", function () {
            down = false;
        });

        let wt = 0;
        rail.addEventListener(
            "wheel",
            function (e) {
                stopAuto();

                if (Math.abs(e.deltaX) < Math.abs(e.deltaY)) {
                    e.preventDefault();
                    rail.scrollLeft += e.deltaY;
                    wrap();
                }

                clearTimeout(wt);
                wt = setTimeout(function () {
                    if (!hover || !finePointer()) startAuto();
                }, 260);
            },
            { passive: false }
        );

        rail.addEventListener("mouseenter", function () {
            hover = true;
            if (finePointer()) stopAuto();
        });

        rail.addEventListener("mouseleave", function () {
            hover = false;
            if (!inertia) startAuto();
        });

        rail.addEventListener(
            "click",
            function (e) {
                if (dragged) e.preventDefault();
            },
            true
        );

        rail.addEventListener("keydown", function (e) {
            if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
                stopAuto();
                rail.scrollBy({
                    left: e.key === "ArrowRight" ? 150 : -150,
                    behavior: "smooth",
                });
                setTimeout(function () {
                    if (!hover) startAuto();
                }, 350);
            }
        });

        let period = 0;
        let group = 0;
        let phase = 0;
        let prev = rail.scrollLeft;

        function ensurePeriod() {
            if (period) return;
            const bg = getComputedStyle(arrowsTop).backgroundSize.split(" ")[0];
            const n = parseFloat(bg);
            period = Number.isFinite(n) ? n : 24;
            group = period * 50;
        }

        function updateArrows() {
            ensurePeriod();
            const lw = getLoopWidth();
            const cur = rail.scrollLeft;
            let dx = cur - prev;

            if (lw) {
                if (dx > lw / 2) dx -= lw;
                else if (dx < -lw / 2) dx += lw;
            }

            phase -= dx;
            phase = phase % group;

            arrowsTop.style.backgroundPositionX = phase + "px";
            arrowsBottom.style.backgroundPositionX = phase + "px";

            prev = cur;
        }

        function step(ts) {
            if (!last) last = ts;
            let dt = (ts - last) / 1000;
            last = ts;

            if (dt > 0.05) dt = 0.05;

            if (inertia) {
                rail.scrollLeft += step.vel * dt;
                wrap();
                step.vel *= Math.pow(FRICTION, dt * 60);

                if (Math.abs(step.vel) < MIN_VEL) {
                    inertia = false;
                    step.vel = 0;
                    if (!hover) startAuto();
                }
            } else if (auto && !down) {
                rail.scrollLeft += AUTO_SPEED * dt;
                wrap();
            } else {
                wrap();
            }

            updateArrows();
            requestAnimationFrame(step);
        }
        step.vel = 0;
        requestAnimationFrame(step);
    }

    function initAll(root) {
        (root || document).querySelectorAll("[data-logo-strip]").forEach(init);
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", function () {
            initAll(document);
        });
    } else {
        initAll(document);
    }
})();

/*! @preserve end */
